import React from "react";
import { Routes, Route } from "react-router-dom";

import DashboardLayout from "../../components/dashboard/Layout";
import LoginPage from "./LoginPage";
import DashboardPage from "./DashboardPage";
import ListPSPPage from "./PSP/ListPSPPage";
import DeploymentsPage from "./DeploymentsPage";
import CreatePSPPage from "./PSP/CreatePSPPage";

const LaunchPadRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />

      {/* Routes that use the layout */}
      <Route element={<DashboardLayout />}>
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="psp" element={<ListPSPPage />} />
        <Route path="deployments" element={<DeploymentsPage />} />
        <Route path="psp/create" element={<CreatePSPPage />} />
      </Route>
    </Routes>
  );
};

export default LaunchPadRoutes;
